import EshopRequestBuilder from "data/eshopRequestBuilder";
import AuthorizationService from "../services/authorizationService";
import RepositoryBase from "./repositoryBase";
import EventBus from "../services/eventBus";
import TradingPlacesResponse from "entities/tradingPlacesResponse";
import { plainToClass } from "class-transformer";
import TradingPlaceDetailResponse from "entities/tradingPlaceDetailResponse";

export default class TradingPlaceRepository extends RepositoryBase<EshopRequestBuilder> {
  constructor(
    protected apiFactory: ReturnType<typeof EshopRequestBuilder.Factory>,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {
    super(() => apiFactory(), authorizationService, eventBus);
  }

  tradingPlaces() {
    return this.callApi(api =>
      api
        .apiVersion(3)
        .all("trading_places")
        .get<TradingPlacesResponse>()
        .then(item => plainToClass(TradingPlacesResponse, item))
    );
  }

  getDetail(itemId: string) {
    return this.callApi(api =>
      api
        .apiVersion(3)
        .one("trading_places", itemId)
        .get<TradingPlaceDetailResponse>()
        .then(item => plainToClass(TradingPlaceDetailResponse, item))
    );
  }
}
